module.exports = __webpack_public_path__ + "static/media/engranajes.d3f3249b.jpg";